module.exports = __webpack_public_path__ + "static/media/merchandiserShadow.c8181312.png";